<div class="order-pricing-wrapper">
    <div class="card">
        <div class="card-header">
            <span class="pull-left"><span translate="cart.order.history.order.number"></span>&nbsp;{{orderView().id}}</span>
        </div>
        <div class="card-body order-summary">
            <span class="fw-bold" translate="cart.order.history.order.status"></span>
            <span class="text-capitalize fw-bold">{{'cart.order.history.order.status.' + orderView().status.toLowerCase() | translate}}</span>
            <span translate="cart.order.history.order.total"></span><span>{{orderView().total | usanacurrency: orderView().currencyCode | async}}</span>
            @if (displayVolume()) {
                <span translate="cart.order.history.order.total.volume"></span><span>{{orderView().totalVolume}}</span>
            }
            <span translate="cart.order.history.order.source"></span>
            <span translate="{{'cart.order.history.source.' + orderView().source}}"></span>
        </div>
    </div>
    <!-- Re-ordering is the black primary; whatever the order needs next (tracking, or paying) is secondary
         and never both at once; auto-order management is tertiary. -->
    <div class="panel-action">
        @switch (trackingCount()) {
            @case (0) {
                <span class="no-action"></span>
            }
            @case (1) {
                <div class="action">
                    @if (!!trackingLink()) {
                        <a class="u-btn u-style-secondary u-shape-round u-size-small"
                           target="_blank" [href]="trackingLink()"
                           [attr.analytics-value]="trackingNumber()">
                            <span translate="cart.order.history.track.package"></span>
                            <i class="fa-solid fa-arrow-up-right-from-square" aria-hidden="true"></i>
                        </a>
                    }
                </div>
            }
            @default {
                <div class="action">
                    <button type="button" class="u-btn u-style-secondary u-shape-round u-size-small"
                            (click)="openOrderTrackingModal(orderView())">
                        <span translate="cart.track.packages"></span>
                    </button>
                </div>
            }
        }
        @if (canManagePayment()) {
            <button type="button" class="u-btn u-style-primary-neutral u-shape-round u-size-small"
                    [disabled]="isPaymentProcessing()"
                    (click)="openManagePaymentModal()">
                <span translate="cart.order.history.manage.payment"></span>
            </button>
            @if (isPaymentProcessing()) {
                <span class="order-payment-processing-message"
                      translate="cart.order.history.payment.processing.message"></span>
            }
        }
        @if (orderView().source === 'APO') {
            <a class="u-btn u-style-tertiary u-shape-round u-size-small"
               [ngClass]="{'disabled-tag': !canAutoOrder()}"
               [routerLink]="canAutoOrder() ? [AUTO_ORDER_MANAGE_ROUTE] : null">
                <span translate="cart.order.history.manage.auto.order"></span>
            </a>
        }
        <span class="tooltip-wrapper"
              [tooltip]="'cart.order.history.cannot.add.order' | translate"
              [isDisabled]="canAddToCart() && !isAddingToCart()">
            <button type="button" class="u-btn u-style-secondary u-shape-round u-size-small"
                    [disabled]="!canAddToCart() || isAddingToCart()"
                    (click)="addFullOrder.emit(orderView().products)">
                <span translate="cart.order.history.add.order.to.cart"></span>
            </button>
        </span>
    </div>
</div>
